// Regal Autosport — International customs consent checkbox fix.
// Prevents the mini cart's change handler from treating the customs
// disclaimer checkbox as a quantity update and re-rendering the cart.
document.addEventListener('DOMContentLoaded', function () {
  if (typeof CartItems === 'undefined') return;
  var _onChange = CartItems.prototype.onChange;
  CartItems.prototype.onChange = function (event) {
    if (event.target.id && event.target.id.includes('international-customs')) return;
    return _onChange.call(this, event);
  };
});
